module.exports = __webpack_public_path__ + "img/11.8217b087.svg";